import { render, staticRenderFns } from "./PopupAddDislikesV1.vue?vue&type=template&id=4bf387a4&scoped=true"
import script from "./PopupAddDislikesV1.vue?vue&type=script&lang=js"
export * from "./PopupAddDislikesV1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf387a4",
  null
  
)

export default component.exports